<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：应用-小程序设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="250px">
      <!--小程序设置-->
      <div class="common-form">极光推送功能设置</div>
      <el-form-item label="推送标题" :rules="[{required: true,message: '请输入推送标题'}]">
        <el-input v-model="form.title" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="推送内容" :rules="[{required: true,message: '请输入推送内容'}]">
        <el-input type="textarea" v-model="form.content" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="推送人员" :rules="[{required: true,message: '请输入推送人员'}]">
        <el-radio-group v-model="form.type">
          <el-radio v-for="(item) in TypeList" :label="item.value" :key="item.value">
            {{item.label}}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>

  </div>

</template>

<script>
import AppSettingApi from "@/api/appsetting.js";

export default {
  data() {
    return {
      form: {},
      TypeList: [
        { label: "用户", value: "1" },
        { label: "技师", value: "2" },
        { label: "全部", value: "3" }
      ]
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      AppSettingApi.getsetMessage({}, true)
        .then(data => {
          if (data.data != null) {
            self.form = data.data.vars.values;
          }
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      let params = this.form;
      AppSettingApi.editsetMessage(params, true)
        .then(data => {
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });
          self.$router.push("/appsetting/appjiguangability/index");
        })
        .catch(error => {});
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appjiguangability/index.vue